import { computed, type Ref } from 'vue';
import { trainingApi } from '@/entities/Training';
import type {
  ExportTrainingListParams,
  TrainingListFilters,
  TrainingListMetadata,
  TrainingListOrder,
  TrainingListSort,
} from '@/entities/Training';
import { useExcelBlobExport } from '@/shared/lib';

interface UseTrainingListExportParams {
  metadata: Ref<TrainingListMetadata | null>;
  term: Ref<string>;
  sort: Ref<TrainingListSort | ''>;
  order: Ref<TrainingListOrder | ''>;
  filters: Ref<TrainingListFilters>;
}

const ENTITY_LABEL = { singular: 'treinamento', plural: 'treinamentos' };

export function useTrainingListExport({
  metadata,
  term,
  sort,
  order,
  filters,
}: UseTrainingListExportParams) {
  const hasExportableItems = computed(() => (metadata.value?.total ?? 0) > 0);

  function buildExportParams(): ExportTrainingListParams {
    const trimmedTerm = term.value.trim();

    return {
      ...filters.value,
      ...(trimmedTerm ? { term: trimmedTerm } : {}),
      ...(sort.value && order.value ? { sort: sort.value, order: order.value } : {}),
    };
  }

  const { handleExportToExcel, isExporting } = useExcelBlobExport(
    () => trainingApi.exportTrainingListExcel(buildExportParams()),
    ENTITY_LABEL
  );

  return {
    handleExportToExcel,
    isExporting,
    hasExportableItems,
  };
}
